import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    confirmLabel: 'Update role',
    invitationInformationMessage:
      'An invitation will be sent to {firstName} {lastName}. The change of role will only be effective once the identity of this person has been verified.',
    invitationSuccess:
      'An invitation to his new role has been sent to {firstName}',
    success: 'The new role have been applied to {firstName}',
  },
  fr: {
    confirmLabel: 'Modifier le rôle',
    invitationInformationMessage:
      'Une invitation va être envoyée à {firstName} {lastName}. Le changement de rôle ne sera effectif qu’une fois l’identité de cette personne vérifiée.',
    invitationSuccess:
      'Une invitation à son nouveau rôle a été envoyée à {firstName}',
    success: 'Le nouveau rôle a été appliqué à {firstName}',
  },
} as const);

export default locales;
